import { useQuery } from "@tanstack/react-query";

import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type { GetDocumentsGroupSearch } from "./apiEcms.types";

const getDocumentsGroupSearch = (signal: AbortSignal) =>
  apiEcmsHttp.get<GetDocumentsGroupSearch>("/documents/group/search", {
    signal,
  });

export const useGetDocumentsGroupSearch = () => {
  const { currentGroup } = useGroupReferences();

  return useQuery({
    queryKey: [QUERY_KEYS.GROUP_DOCUMENTS, currentGroup],
    queryFn: ({ signal }) => getDocumentsGroupSearch(signal),
  });
};
